export enum InvoiceAddressType {
  INDIVIDUAL = 'Individual',
  CORPORATE = 'Corporate',
}
